import React from 'react';
import $ from 'jquery';

const Demo = () => {
  const handleExport = () => {
    // Get table content with inline styles
    const table = $("#myTable");
    let tableHtml = `
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
          <!--[if gte mso 9]><xml>
          <x:ExcelWorkbook>
          <x:ExcelWorksheets>
            <x:ExcelWorksheet>
              <x:Name>Sheet1</x:Name>
              <x:WorksheetOptions>
                <x:DisplayGridlines/>
              </x:WorksheetOptions>
            </x:ExcelWorksheet>
          </x:ExcelWorksheets>
          </x:ExcelWorkbook>
          </xml><![endif]-->
        </head>
        <body>
          ${table[0].outerHTML}
        </body>
      </html>
    `;

    // Create a Blob with the table data in Excel format
    const blob = new Blob([tableHtml], { type: "application/vnd.ms-excel" });

    // Create a download link
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "table_data.xls"; // Set the filename
    link.click();
  };

  return (
    <div>
      <table
        id="myTable"
        className="table"
        style={{ borderCollapse: "collapse", border: "1px solid black" }}
      >
        <thead>
          <tr>
            <th style={{ border: "1px solid black" }}>Name</th>
            <th style={{ border: "1px solid black" }}>Age</th>
            <th style={{ border: "1px solid black" }}>Country</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid black" }}>John</td>
            <td style={{ border: "1px solid black" }}>30</td>
            <td style={{ border: "1px solid black" }}>USA</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Maria</td>
            <td style={{ border: "1px solid black" }}>25</td>
            <td style={{ border: "1px solid black" }}>Canada</td>
          </tr>
        </tbody>
      </table>
      <button onClick={handleExport} className="btn btn-primary">
        Export to Excel
      </button>
    </div>
  );
};

export default Demo;
